import orderConstants from 'utils/order/constants';

/**
 * Get a route summary through the shipments. ex: Madrid - Barcelona
 */
export const getRoute = (shipments, orderType) =>
  Object.values(shipments).reduce((current, shipment, i) => {
    const from = shipment.address_from.label;
    const to = shipment.address_to.label;
    if (i === 0) {
      return `${from} - ${to}`;
    }
    if (orderType === orderConstants.COLLECTION) {
      return `${current} - ${from}`;
    }
    return `${current} - ${to}`;
  }, '');
